module.exports = "<h2 class=\"text-center\">\n  Editing Detail for Product: \n</h2>\n<h1 class=\"text-center\">\n  {{product?.product_title}}\n</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/products/product-detail/product-detail-edit/product-detail-edit.component.html
// module id = ./src/app/components/products/product-detail/product-detail-edit/product-detail-edit.component.html
// module chunks = main